<template>
  <div id="gallery" class="mb-5 pb-5">
    <article class="title py-4 bg-third text-white">
      <b-container fluid>
        <h1 class="text-21 text-lg-32 pl-1 fw-700">
          갤러리
        </h1>
      </b-container>
    </article>
    <b-container fluid class="my-3 my-md-5 py-3 py-md-5">
      <template v-if="galleryImages && galleryImages.length">
        <b-row>
          <b-col
            cols="12"
            md="6"
            lg="4"
            class="mb-4 image-el"
            v-for="(image, i) in galleryImages"
            :key="'image-' + i"
          >
            <img :src="image.src" class="w-100" @click="showDetail(image)" />
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <section class="loading text-center">
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
        </section>
      </template>
    </b-container>
    <b-modal id="gallery-detail" size="xl">
      <template v-if="currentImage && currentImage.src">
        <img :src="currentImage.src" />
      </template>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-start">
          <!-- <b-btn variant="primary ml-0 mr-auto" @click="download(currentImage)"
            >이미지 다운로드</b-btn
          > -->
          <span class="text-14 text-lg-14">
            이미지를 마우스 오른쪽 버튼 클릭하여 이미지를 저장하거나, 꾹 눌러
            저장할 수 있습니다.(브라우저, 기기마다 방법이 차이가 있습니다.)
          </span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | " + "갤러리",
    };
  },
  data() {
    return {
      galleryImages: [],
      currentImage: null,
    };
  },
  methods: {
    loadAllGalleryImages() {
      this.$db
        .collection("galleryImages")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.galleryImages = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    showDetail(image) {
      this.$bvModal.show("gallery-detail");
      this.currentImage = image;
    },
  },
  async mounted() {
    await this.loadAllGalleryImages();
  },
};
</script>

<style lang="scss" scoped>
.image-el {
  cursor: pointer;
  img {
    transition: 0.3s;
  }
  &:hover {
    img {
      transform: scale(1.1);
      box-shadow: 0 2px 56px rgba($color: #222, $alpha: 0.3);
    }
  }
}
</style>
